module.exports = __webpack_public_path__ + "static/media/comments-alt-dollar.ede37976.svg";